function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from 'lodash';
export var labelClass = {
  id: 0,
  name: 'name',
  color: {
    hex: '#9c27b0',
    rgb: {
      a: 1,
      r: 61,
      g: 15,
      b: 69
    }
  },
  dispose: false,
  images: []
};

var labelClasses = function labelClasses() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    targetClassId: 0,
    list: []
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'ADD_LABEL_CLASS':
      return _objectSpread(_objectSpread({}, state), {}, {
        targetClassId: action.id,
        list: [].concat(_toConsumableArray(state.list), [_objectSpread(_objectSpread({}, labelClass), {}, {
          id: action.id,
          name: "Class ".concat(action.id)
        })])
      });

    case 'SET_LABEL_CLASS_NAME':
      return _objectSpread(_objectSpread({}, state), {}, {
        list: _.map(state.list, function (labelClass) {
          if (labelClass.id === action.id) {
            return _objectSpread(_objectSpread({}, labelClass), {}, {
              name: action.name
            });
          }

          return labelClass;
        })
      });

    case 'SET_LABEL_CLASS_COLOR':
      return _objectSpread(_objectSpread({}, state), {}, {
        list: _.map(state.list, function (labelClass) {
          if (labelClass.id === action.id) {
            return _objectSpread(_objectSpread({}, labelClass), {}, {
              color: action.color
            });
          }

          return labelClass;
        })
      });

    case 'DELETE_LABEL_CLASS':
      return _objectSpread(_objectSpread({}, state), {}, {
        list: _.reject(state.list, {
          id: action.id
        })
      });

    case 'DELETE_ALL_IMAGES':
      return _objectSpread(_objectSpread({}, state), {}, {
        list: _.map(state.list, function (labelClass) {
          if (labelClass.id === action.id) {
            return _objectSpread(_objectSpread({}, labelClass), {}, {
              images: []
            });
          }

          return labelClass;
        })
      });

    case 'ADD_IMAGE':
      return _objectSpread(_objectSpread({}, state), {}, {
        list: _.map(state.list, function (labelClass) {
          if (labelClass.id === action.id) {
            return _objectSpread(_objectSpread({}, labelClass), {}, {
              images: [].concat(_toConsumableArray(labelClass.images), [action.image])
            });
          }

          return labelClass;
        })
      });

    case 'REMOVE_IMAGE':
      return _objectSpread(_objectSpread({}, state), {}, {
        list: _.map(state.list, function (labelClass) {
          if (labelClass.id === action.id) {
            return _objectSpread(_objectSpread({}, labelClass), {}, {
              images: _.reject(labelClass.images, function (_, i) {
                return i === action.imageIndex;
              })
            });
          }

          return labelClass;
        })
      });

    case 'TOGGLE_DISPOSE_STATE':
      return _objectSpread(_objectSpread({}, state), {}, {
        list: _.map(state.list, function (labelClass) {
          if (labelClass.id === action.id) {
            return _objectSpread(_objectSpread({}, labelClass), {}, {
              dispose: !labelClass.dispose
            });
          }

          return labelClass;
        })
      });

    case 'CHANGE_TARGET_CLASS':
      return _objectSpread(_objectSpread({}, state), {}, {
        targetClassId: action.id
      });

    default:
      return state;
  }
};

export var getLabelClassByName = function getLabelClassByName(labelClasses, name) {
  return _.find(labelClasses, function (lc) {
    return lc.name === name;
  });
};
export default labelClasses;